import axios from "axios";
window.addEventListener("DOMContentLoaded", () => {
	let give_a_like = document.querySelector(".give_a_like");
	let ungive_a_like = document.querySelector(".ungive_a_like");
	let give_a_follow = document.querySelector(".give_a_follow");
	let ungive_a_follow = document.querySelector(".ungive_a_follow");

	if (give_a_like) {
		give_a_like.addEventListener("click", () => {
			let form_data = new FormData();
			form_data.append("action", "givealike");
			form_data.append("sgo", give_a_like.dataset.ong);
			axios.post(ajaxurl, form_data)
				.then((data) => {
					if (data.data.message === "redirect") {
						window.location.href = "https://thedotgood.net/access-a-world-of-information/";
					} else {
						give_a_like.querySelector("span").innerHTML = data.data.message;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		});
	}
	if (ungive_a_like) {
		ungive_a_like.addEventListener("click", () => {
			let form_data = new FormData();
			form_data.append("action", "givealike");
			form_data.append("sgo", ungive_a_like.dataset.ong);
			axios.post(ajaxurl, form_data)
				.then((data) => {
					if (data.data.message === "redirect") {
						window.location.href = "https://thedotgood.net/access-a-world-of-information/";
					} else {
						ungive_a_like.querySelector("span").innerHTML = data.data.message;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		});
	}
	if (give_a_follow) {
		give_a_follow.addEventListener("click", () => {
			let form_data = new FormData();
			form_data.append("action", "giveafollow");
			form_data.append("sgo", give_a_follow.dataset.ong);
			axios.post(ajaxurl, form_data)
				.then((data) => {
					if (data.data.message === "redirect") {
						window.location.href = "https://thedotgood.net/access-a-world-of-information/";
					} else {
						give_a_follow.querySelector("span").innerHTML = data.data.message;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		});
	}
	if (ungive_a_follow) {
		ungive_a_follow.addEventListener("click", () => {
			let form_data = new FormData();
			form_data.append("action", "giveafollow");
			form_data.append("sgo", ungive_a_follow.dataset.ong);
			axios.post(ajaxurl, form_data)
				.then((data) => {
					if (data.data.message === "redirect") {
						window.location.href = "https://thedotgood.net/access-a-world-of-information/";
					} else {
						ungive_a_follow.querySelector("span").innerHTML = data.data.message;
					}
				})
				.catch((err) => {
					console.log(err);
				});
		});
	}
});
